import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AdminTenantAdaptor } from '@app/core/adaptors/admin-tenant.adaptor';
import {
  AdminTenantDetail,
  AdminTenantsPageResponse,
  AdminTenantSearchCriteria,
  CreateTenantDto,
  CreateTenantResponse,
  CreateTrialTenantDto,
  CreateTrialTenantResponse,
} from '@app/core/models/admin-tenant.interface';

@Injectable({ providedIn: 'root' })
export class AdminTenantService {
  private adaptor = inject(AdminTenantAdaptor);

  listTenants(criteria: AdminTenantSearchCriteria): Observable<AdminTenantsPageResponse> {
    return this.adaptor.listTenants(criteria);
  }

  createTenant(dto: CreateTenantDto): Observable<CreateTenantResponse> {
    return this.adaptor.createTenant(dto);
  }

  createTrialTenant(dto: CreateTrialTenantDto): Observable<CreateTrialTenantResponse> {
    return this.adaptor.createTrialTenant(dto);
  }

  getTenant(tenantId: number): Observable<AdminTenantDetail> {
    return this.adaptor.getTenant(tenantId);
  }

  deactivateTenant(tenantId: number): Observable<AdminTenantDetail> {
    return this.adaptor.updateTenantStatus(tenantId, { status: 'INACTIVE' });
  }

  reactivateTenant(tenantId: number): Observable<AdminTenantDetail> {
    return this.adaptor.updateTenantStatus(tenantId, { status: 'ACTIVE' });
  }
}
